const debug = false;
let vippsClientId = "e84106c9-d0c6-418c-9b32-3cc354387f2e";
let modishMinsideUrl = "https://minside.modish.no";
let loyaltySlug = "ztil";
let shopDomain = "ztil.myshopify.com";
let termsConditionsPage = "/pages/terms";
let vippsState = uuidv4();


let apiPath = "/api/shopify/register";

//Query string parameters
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

//Container elements
const messageContainer = document.getElementById("modish-message-container");
const continueWithMobileContainer = document.getElementById(
  "modish-continue-with-mobile-container"
);
const loginCheckIfMemberContainer = document.getElementById(
  "login-check-if-member-container"
);
const personalDetailsContainer = document.getElementById(
  "personal-details-container"
);

//Button elements
const continueWithMobileBtn = document.getElementById(
  "modish-continue-with-mobile-btn"
);
const vippsBtn = document.getElementById("vipps-btn");
const termsConditionsButton = document.getElementById("terms-conditions-btn");

//Form elements
const checkMsisdnForm = document.getElementById("modish-check-msisdn-form");
const modishMemberForm = document.getElementById("modish-member-form");
const hiddenMsisdn = document.getElementById("hidden-msisdn");

//set the shop domain inputs
// Step 1: Get all input elements with name "shop_domain"
var inputElements = document.querySelectorAll('input[name="shop_domain"]');

// Step 2: Set the value for each input element
inputElements.forEach(function (element) {
  element.value = shopDomain;
});

/*************************************************
  Check if opt_in_channel (oic) is set in 
  the query param and add it to the Vipps 
  state query param for tracking
*************************************************/
const oic = urlParams.get("oic");
if (oic) {
  vippsState += "--" + oic;
}

/*************************************************
  Check if user has returned from 
  Vipps registration
*************************************************/

const vippsMsisdn = urlParams.get("vipps_msisdn");
if (vippsMsisdn) {
  hiddenMsisdn.value = vippsMsisdn;
  loginCheckIfMemberContainer.style.display = "none";
  //Hide the personal details (except gender) as we get this from Vipps
  personalDetailsContainer.remove();
  modishMemberForm.style.display = "block";
  apiPath = "/api/shopify/vipps/complete";
}

/*************************************************
  Check if user is returned from Vipps and 
  is already a member
*************************************************/
const isMember = urlParams.get("er_medlem");
if (isMember) {
  showMessage("Du er allerede medlem i kundeklubben");
}

/*************************************************
  Vipps/Check mobile number form
*************************************************/

vippsBtn.href =
  "https://api.vipps.no/access-management-1.0/access/oauth2/auth?client_id=" +
  vippsClientId +
  "&response_type=code&scope=openid%20name%20phoneNumber%20email%20address%20birthDate&state=" +
  vippsState +
  "&redirect_uri=" +
  modishMinsideUrl +
  "/api/shopify/vipps/" +
  loyaltySlug;

//Show mobile number input
continueWithMobileBtn.addEventListener("click", function (e) {
  e.preventDefault();
  continueWithMobileContainer.classList.add("show");
  continueWithMobileBtn.classList.add("hide");
  document.getElementById("msisdn").focus();
});

checkMsisdnForm.addEventListener("submit", function (e) {
  e.preventDefault();
  hideMessage();
  checkIfMember(this, function (response, status) {
    if (status != 200) {
      for (var error in response.errors) {
        showError("<p>" + response.errors[error] + "</p>");
      }
    } else {
      if (!response.is_member) {
        loginCheckIfMemberContainer.style.display = "none";
        modishMemberForm.style.display = "block";
        hiddenMsisdn.value = response.msisdn;
      } else {
        showMessage("Du er allerede medlem i kundeklubben");
      }
    }
  });
  return false;
});

/*************************************************
  Registration form
*************************************************/

termsConditionsButton.href = termsConditionsPage;

modishMemberForm.addEventListener("submit", function (e) {
  e.preventDefault();
  hideMessage();
  var xhttp = new XMLHttpRequest();

  xhttp.open("POST", modishMinsideUrl + apiPath, true);
  xhttp.setRequestHeader("Accept", "application/json");
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4) {
      let response = JSON.parse(this.responseText);
      if (this.status == 200) {
        modishMemberForm.style.display = "none";
        showMessage("Velkommen som medlem i kundeklubben");
      } else if (response.errors) {
        for (var error in response.errors) {
          showError("<p>" + response.errors[error][0] + "</p>");
        }
      }
    }
  };
  xhttp.send(new FormData(modishMemberForm));
});

/*************************************************
  General functions
*************************************************/
function showError(error) {
  messageContainer.classList.add("error");
  messageContainer.classList.remove("success");
  messageContainer.innerHTML += error;
  messageContainer.style.display = "block";
}

function showMessage(message) {
  messageContainer.classList.add("success");
  messageContainer.classList.remove("error");
  messageContainer.innerHTML += message;
  messageContainer.style.display = "block";
}

function hideMessage() {
  messageContainer.classList.remove("success");
  messageContainer.classList.remove("error");
  messageContainer.innerHTML = "";
  messageContainer.style.display = "none";
}

function checkIfMember(form, callback) {
  var xhttp = new XMLHttpRequest();
  xhttp.open("POST", modishMinsideUrl + "/api/shopify/check_member", true);
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4) {
      let response = JSON.parse(this.responseText);
      callback(response, this.status);
    }
  };
  xhttp.send(new FormData(form));
}

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getQueryStringParameters() {
  var parameters = {},
    hash;
  var q = document.URL.split("?")[1];
  if (q != undefined) {
    q = q.split("&");
    for (var i = 0; i < q.length; i++) {
      hash = q[i].split("=");
      parameters[hash[0]] = hash[1];
    }
  }
  return parameters;
}

(function () {
  const inputs = document.getElementsByClassName("autocomplete");
  let params = getQueryStringParameters();
  for (let i = 0; i < inputs.length; i++) {
    let el = inputs[i];
    if (el.value == "" && params[el.dataset.key] !== undefined) {
      el.value = decodeURIComponent(params[el.dataset.key]);
    }
  }
})();
